<template>
  <div class="w-full pt-5 pb-5">
    <div class="flex">
      <back-button
        label="Back"
        @onClick="
        $router.push({
          name: 'PayrollSettings',
          query: { payType: 'Earnings', orgPaySettingId: orgPaySettingId },
        });
        "
        variant="secondary"
        class="mr-4"
      />
      <div
        class="mt-4"
        style="border-left: 1px solid #878e99; height: 1.5rem"
      />

      <div style="width: 220px">
        <h1 class="text-xl text-left font-extrabold ml-4 mt-3">
          {{ isEditState ? "Edit Earnings" : "New Earnings" }}
        </h1>
      </div>
      <div class="w-7/12 mt-4">
        <Breadcrumb :items="breadcrumbs" />
      </div>
    </div>
    <div style="height: 100%" v-if="loading">
      <loader size="xxs" :loader-image="false" />
    </div>
    <div v-else class="px-3">
      <ValidationObserver rules="required" v-slot="{ handleSubmit }">
        <card class="p-5 mt-6">
          <p class="text-lg font-bold">Earning Details</p>
          <div class="grid grid-cols-12 gap-7" style="margin-top: 1.125rem">
            <div class="col-span-4">
              <div class="text-sm text-jet">Pay Item</div>
              <c-select
                placeholder="--Select--"
                :options="payItemList"
                :disabled="isEditState"
                v-model="earningCredential.payItemId"
                @onChange="handlePayItem($event)"
                variant="w-full"
              />
              <div
                v-if="
                  earningCredential.payItemSlug === 'advance' ||
                  earningCredential.payItemSlug === 'loan'
                "
              >
                <div class="text-sm text-gray-500">
                  Global Advance and Loan Limit is {{ advanceAndLoanLimit }}% of
                  Annual Gross.
                  <button
                    @click="openAdvanceAndLoansSidebar = true"
                    class="font-bold text-blue-500"
                  >
                    Change limit
                  </button>
                </div>
              </div>
            </div>
            <div class="col-span-4">
              <c-text
                placeholder="Enter"
                variant="w-full"
                label="Name in Payslip"
                :rules="payslipRule"
                v-model="earningCredential.nameOnPayslip"
              />
            </div>
            <div class="col-span-4">
              <div class="text-sm text-jet">Earning Type</div>
              <c-select
                placeholder="--Select--"
                :options="payItemType"
                variant="w-full"
                v-model="earningCredential.payType"
                :rules="['required']"
              />
            </div>
            <div class="col-span-4">
              <div class="text-base text-jet">
                Include pay item in annual gross pay?
              </div>
              <c-select
                placeholder="--Select--"
                :options="grossPayArray"
                variant="w-full"
                v-model="earningCredential.includedInGrossPay"
                @onChange="booleanGross($event)"
                :disabled="earningCredential.payItemSlug === 'loan' || earningCredential.payItemSlug === 'advance'"
              />

              <!----- <radio-button
                :options="grossPayArray"
                col-span="col-span-1"
                class="mt-4 text-darkPurple pl-4"
                row-gap="gap-y-1"
                v-model="earningCredential.includedInGrossPay"
                :disabled="isDisabled"
              /> --->
            </div>
            <div class="col-span-4">
              <div class="text-sm text-jet">Rate Type</div>
              <c-select
                placeholder="--Select--"
                :options="rateTypes"
                variant="w-full"
                @onChange="handleRateType($event)"
                v-model="earningCredential.rateTypeSlug"
                :disabled="earningCredential.payItemSlug === 'loan' || earningCredential.payItemSlug === 'advance' || disabledRateType"
              />
            </div>
            <div class="col-span-4">
              <div
                v-if="earningCredential.payItemSlug === 'advance'"
                class="text-sm font-extrabold text-jet"
              >
                <c-text
                  placeholder="Enter Advance Limit"
                  variant="w-full"
                  type="number"
                  min="0"
                  label="Advance Limit(%)"
                  @keydown="blockNegativeNumberInput"
                  @input="updateLevelsValue"
                  v-model="rateValue"
                />
              </div>
              <div
                v-else-if="earningCredential.payItemSlug === 'loan'"
                class="text-sm text-jet"
              >
                <c-text
                  placeholder="Enter Loan Limit"
                  variant="w-full"
                  type="number"
                  min="0"
                  label="Loan Limit(%)"
                  @keydown="blockNegativeNumberInput"
                  @input="updateLevelsValue"
                  v-model="rateValue"
                />
              </div>
              <c-text
                placeholder="Enter Rate Value"
                variant="w-full"
                :rules="['required']"
                v-else
                :errors="error"
                type="number"
                min="0"
                label="Rate Value"
                @keydown="blockNegativeNumberInput"
                @input="updateLevelsValue"
                v-model="rateValue"
              />
            </div>

            <div
              class="col-span-4"
              v-if="
                !earningCredential.includedInGrossPay &&
                earningCredential.payType === 'regular'
              "
            >
              <div class="flex items-center gap-3">
                <div class="text-sm text-jet">Pay Off-Cycle?</div>
                <label class="switch ml-auto">
                  <input
                    type="checkbox"
                    :checked="earningCredential.payOffCycle"
                    @change="handleOffCycle($event.target.checked)"
                  />
                  <span class="slider round"></span>
                </label>
              </div>

              <div v-if="earningCredential.payItemSlug === 'month13' && !earningCredential.payOffCycle" class=" mt-4">
                <div class="warning mt-5 border border-[#E993235C] bg-[#E9932314] ">
                  <Icon icon-name="icon-info-color" size="m" class=" mr-2" style="fill: transparent;"/>
                  <p>Your 13th month will be calculated and added to your December payroll.</p>
                </div>
              </div>

              <div
              class="col-span-4"
              v-if="
                !earningCredential.includedInGrossPay &&
                earningCredential.payType === 'regular' &&
                earningCredential.payOffCycle
              "
            >
              <div class="date-flex mt-1">
                <datepicker
                  placeholder="--Enter--"
                  input-class="date-input"
                  style="width: 100%; outline: none"
                  :minimum-view="'days'"
                  :maximum-view="'month'"
                  format="dd MMMM"
                  :disabled-dates="disabledRepaymentDates"
                  @selected="handlePayDate($event)"
                  v-model="payDate"
                />
              </div>
              </div>
            </div>

            <div class="col-span-12" />
          </div>
        </card>

        <card
          class="p-5 mt-6"
          v-if="
            earningCredential.payItemSlug === 'advance' ||
            earningCredential.payItemSlug === 'loan'
          "
        >
          <p class="text-lg font-bold">Request Cut-off Date</p>
          <p class=" mb-2 text-sm text-gray-600">
            Please specify the last date to submit advance requests for processing in the upcoming payroll cycle.
          </p>
          <div class="grid grid-cols-12 gap-7 mt-6">
            <div class="col-span-12">
              <div class="flex items-center gap-4">
                <div class="flex items-end gap-2">
                  <div style="width: 120px">
                    <c-select
                      placeholder="--Select--"
                      label="Cut-Off Date"
                      :options="daysArray"
                      variant="w-full"
                      v-model="earningCredential.payrollCutoffDay"
                    />
                  </div>
                  <div style="width: 140px">
                    <c-text
                      placeholder=""
                      variant="w-full"
                      type="string"
                      v-model="payMonthType"
                      :disabled="true"
                    />
                  </div>
                </div>
                <div class=" ml-4 mt-4">
                  <div class="warning mt-5 border border-[#E993235C] bg-[#E9932314] ">
                    <Icon icon-name="warning" size="xs" class=" mr-2" style="fill: transparent;"/>
                    <p>All requests beyond this date will be processed in the next payroll cycle.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </card>

        <card
          class="p-5 mt-6"
          v-if="
            earningCredential.payItemSlug === 'advance' ||
            earningCredential.payItemSlug === 'loan'
          "
        >
          <p class="text-lg font-bold">Eligibility</p>
          <p class=" mb-2 text-sm text-gray-600">
            Select employee groups entitled to an advance.
          </p>
          <div class="grid grid-cols-12 gap-7 mt-4">
            <div class="col-span-12 flex flex-row gap-2">
              <div
                v-for="option in eligibilityCheckboxArray"
                :key="option.value"
                class="mb-3"
              >
                <checkbox
                  :label="option.name"
                  v-model="option.option"
                  :value="option.value"
                  label-style="color:#333333; font-size: 14px;"
                  checkbox-size="height:16px; width:16px; cursor:pointer"
                />
              </div>
            </div>
          </div>


          <p class="text-lg font-bold mt-6">Exceptions</p>
          <p class=" mb-2 text-sm text-gray-600">
            Select exceptions to the eligibility criteria.
          </p>
          <div class="grid grid-cols-12 gap-7 mt-4">
            <div class="col-span-12 flex flex-row gap-2 flex-wrap w-full">
              <div
                v-for="option in exceptionsCheckboxArray"
                :key="option.value"
                class="mb-3"
              >
                <checkbox
                  :label="`Outstanding ${earningCredential.payItemSlug === 'loan' ? `loan` : `Advance`} repayment balance`"
                  v-model="earningCredential.requiresNoOutstandingLoans"
                  :value="option.value"
                  :disabled="option.status === 'disabled'"
                  label-style="color:#333333; font-size: 14px;"
                  checkbox-size="height:16px; width:16px;"
                />
              </div>
            </div>
          </div>
        </card>

        <card
          class="p-5 mt-6"
          v-if="
            earningCredential.payItemSlug === 'advance' ||
            earningCredential.payItemSlug === 'loan'
          "
        >
          <p class="text-lg font-bold">Limitations</p>
          <p class=" mb-2 text-sm text-gray-600">
            Define the total exposure amount for your organisation at any given time.
          </p>
          <div class="grid grid-cols-12 gap-7 mt-4">
            <div class="col-span-4">
              <div class="text-sm text-jet mb-1">
                Total Monthly Limit (Organisation)
              </div>
              <c-text
                placeholder="--Enter--"
                v-model="earningCredential.advanceMonthlyLimit"
                variant="w-full"
                type="number"
                min="0"
                @keydown="blockNegativeNumberInput"
                @input="onCredentialNumberInput('advanceMonthlyLimit', $event)"
              />
            </div>
          </div>


          <p class="text-lg font-bold mt-6">Repayment Duration</p>
          <p class=" mb-2 text-sm text-gray-600">
            Define the maximum repayment duration allowable for employees.
          </p>
          <div class="grid grid-cols-12 gap-7 mt-4">
            <div class="col-span-4">
              <div class="text-sm text-jet mb-1">Maximum Repayment Duration</div>
              <div class="flex items-center gap-2">
                <div class="">
                  <c-text
                    placeholder=""
                    v-model="earningCredential.advanceRepaymentDuration"
                    variant="w-4/12"
                    type="number"
                    min="0"
                    @keydown="blockNegativeNumberInput"
                    @input="onCredentialNumberInput('advanceRepaymentDuration', $event)"
                  />
                </div>
                <div class="">
                  <c-text
                    placeholder=""
                    value="Month(s)"
                    variant="w-4/12"
                    type="text"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>


          <p class="text-lg font-bold mt-6">Interest Settings</p>
          <div class="grid grid-cols-12 gap-7 mt-4">
            <div class="col-span-12">
              <div class="text-base text-jet mb-2">Is this Interest based?</div>
              <radio-button
                :options="taxableArray"
                col-span="col-span-1"
                class="ml-4 mb-0 text-darkPurple"
                v-model="earningCredential.advanceIsInterestBased"
              />
            </div>
            <div
              v-if="
                earningCredential.advanceIsInterestBased === 'true' ||
                earningCredential.advanceIsInterestBased === true
              "
              class="col-span-4 mt-2"
            >
              <div class="text-base text-jet mb-1">Interest(%)</div>
              <c-text
                placeholder="Interest value"
                variant="w-full"
                type="number"
                min="0"
                @keydown="blockNegativeNumberInput"
                @input="onCredentialNumberInput('interest', $event)"
                v-model="earningCredential.interest"
              />
            </div>
          </div>
        </card>


        <card v-if="earningCredential.payItemSlug === 'advance' || earningCredential.payItemSlug === 'loan'" class="p-5 mt-6">
          <p class="text-lg font-bold">Additional Settings</p>
          <div class="flex flex-row flex-wrap gap-7" style="margin-top: 1.125rem">
            <div class="">
              <div class="text-base text-jet">
                Enable Pay Item?
              </div>
              <radio-button
                :options="activeArray"
                col-span="col-span-5"
                class="m-4 text-darkPurple"
                row-gap="gap-x-4"
                :disabled="disableIsActive"
                v-model="earningCredential.isActive"
              />
            </div>
            <div class="col-span-4">
              <div class="text-base text-jet">
                Allow Value/ Formula Override
              </div>
              <radio-button
                :options="allowValueOverrideArray"
                col-span="col-span-5"
                class="m-4 text-darkPurple"
                row-gap="gap-x-4"
                v-model="earningCredential.allowValueFormulaOverride"
              />
            </div>
          </div>
        </card>
        <card v-else class="p-5 mt-6">
          <p class="text-lg font-bold">Additional Settings</p>
          <div class="flex flex-row flex-wrap gap-7" style="margin-top: 1.125rem">
            <div class="">
              <div class="text-base text-jet">
                Enable Pay Item?
              </div>
              <radio-button
                :options="activeArray"
                col-span="col-span-5"
                class="m-4 text-darkPurple"
                row-gap="gap-x-4"
                :disabled="disableIsActive"
                v-model="earningCredential.isActive"
              />
            </div>
            <div class="">
              <div class="text-base text-jet">Apply PAYE?      </div>
              <radio-button
                :options="earningArray"
                col-span="col-span-5"
                class="m-4 text-darkPurple"
                row-gap="gap-x-4"
                v-model="earningCredential.isTaxable"
              />
            </div>
            <div class="mx-5">
              <div class="text-base text-jet">
                Prorate Pay Item?
              </div>
              <radio-button
                :options="basisArray"
                col-span="col-span-5"
                class="m-4 text-darkPurple"
                row-gap="gap-x-4"
                v-model="earningCredential.calculateProrata"
              />
            </div>
            <div class="">
              <div class="text-base text-jet">
                Apply Pension?
              </div>
              <radio-button
                :options="contributionArray"
                col-span="col-span-5"
                class="m-4 text-darkPurple"
                :disabled="
                  earningCredential.payItemSlug === 'basic' ||
                  earningCredential.payItemSlug === 'transportAllowance' ||
                  earningCredential.payItemSlug === 'housingAllowance'
                "
                row-gap="gap-x-4"
                v-model="earningCredential.isPartOfPension"
              />
            </div>
            <div class="col-span-4">
              <div class="text-base text-jet">
                Allow Value/ Formula Override
              </div>
              <radio-button
                :options="allowValueOverrideArray"
                col-span="col-span-5"
                class="m-4 text-darkPurple"
                row-gap="gap-x-4"
                v-model="earningCredential.allowValueFormulaOverride"
              />
            </div>
          </div>
        </card>


        <div class="flex my-5 float-right">
          <div class="flex">
            <Button
              class="inline-block bg-dynamicBackBtn text-white buttons rounded-md"
              :disabled="creatingEarnings"
              @click="handleSubmit(saveEarnings)"
            >
              Save
            </Button>
            <Button
              @click="
                $router.push({
                  name: 'PayrollSettings',
                  query: { payType: 'Earnings' },
                })
              "
              class="buttons inline-block"
            >
              Cancel
            </Button>
          </div>
        </div>
      </ValidationObserver>
    </div>
    <global-advance-and-loans
      :open-modal="openAdvanceAndLoansSidebar"
      @close="openAdvanceAndLoansSidebar = false"
      @save-advance-and-loan="setAdvanceAndLoanLimit"
    />
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import Datepicker from "vuejs-datepicker";
import BackButton from "@scelloo/cloudenly-ui/src/components/back-button";
import Breadcrumb from "@scelloo/cloudenly-ui/src/components/bread-crumb";
import CText from "@scelloo/cloudenly-ui/src/components/text";
import CSelect from "@scelloo/cloudenly-ui/src/components/select";
import Card from "@/components/Card";
import RadioButton from "@/components/RadioButton";
import Checkbox from "@/components/Checkbox";
import Button from "@/components/Button";
import GlobalAdvanceAndLoans from "./GlobalAdvanceAndLoans";

export default {
  name: "NewEarnings",
  components: {
    ValidationObserver,
    BackButton,
    Datepicker,
    Breadcrumb,
    Card,
    CText,
    CSelect,
    RadioButton,
    Checkbox,
    Button,
    GlobalAdvanceAndLoans,
  },
  data() {
    return {
      payMonthType: 'every month',
      isEditState: !!this.$route.params.id,
      openAdvanceAndLoansSidebar: false,
      advanceAndLoanLimit: "",
      isVisible: false,
      isAppointment: false,
      payItemList: [],
      isPayRequest: "false",
      dateVisible: "true",
      // monthVisible: false,
      orgPaySettingId: this.$store.state.paySettingsActiveIds.ACTIVE,
      isShowMonth: false,
      isDisabledRequest: false,
      isDisabled: true,
      creatingEarnings: false,
      number: null,
      currentGrossPercentage: 0,
      previousRateValue: 0,
      previousInGrossPay: false,
      payDate: null,
      earningCredential: {
        orgId: "",
        settingType: "earnings",
        payOffCycle: false,
        payItemId: "",
        payItemSlug: "",
        payType: "",
        rateTypeSlug: "",
        rateValue: null,
        nameOnPayslip: "",
        includedInGrossPay: false,
        isTaxable: false,
        calculateProrata: false,
        showInPayslip: false,
        payOnRequest: false,
        payMonth: null,
        payrollCutoffDay: null,
        addsToDecember: false,
        has13MonthFixedPay: false,
        month13IsTaxable: false,
        month13RateType: null,
        month13RateValue: null,
        advanceEligibility: "confirmation",
        advanceEligibilityDays: null,
        advanceMonthlyLimit: null,
        advanceCutoffDate: null,
        isPartOfPension: true,
        advanceRepaymentDuration: null,
        advanceIsInterestBased: false,
        interest: 0,
        requiresApproval: false,
        isActive: true,
        includedInTotalEmpCost: true,
        employeeSetsPayStart: false,
        payStartDay: null,
        maximumEmployeeApplicableDays: null,
        requiresNoOutstandingLoans: null,
        levelsSettings: [],
        allowValueFormulaOverride: false,
        eligibilityGroups: [],
        exceptionsGroups: [],
      },
      selectedPayItem: null,
      rateType: {},
      ratingType: [],
      activeTab: {},
      breadcrumbs: [
        {
          disabled: false,
          text: "Settings",
          href: "settings",
          id: "Settings",
        },
        {
          disabled: false,
          text: "Payroll Settings",
          id: "Payroll Settings",
        },
        {
          disabled: false,
          text: this.$route.params.id ? "Edit Earnings" : "New Earnings",
          id: "New Earnings",
        },
      ],
      grossPayArray: [
        { name: "Yes", id: "true" },
        { name: "No", id: "false" },
      ],
      taxableArray: [
        { name: "Yes", radioName: "taxable", value: true },
        { name: "No", radioName: "taxable", value: false },
      ],
      eligibilityArray: [
        { name: "On Appointment", radioName: "eligibility", value: true },
        { name: "On Confirmation", radioName: "eligibility", value: false },
      ],
      eligibilityCheckboxArray: [
        { name: "Full-time confirmed employees", checkboxName: "eligibility", value: "fulltimeConfirmed", option: [] },
        { name: "Employees on probation", checkboxName: "eligibility", value: "probation", option: [] },
        // { name: "Contract, temporal, and part-time employees", checkboxName: "eligibility", value: "contractTemporalParttime", option: [] },
      ],
      exceptionsCheckboxArray: [
        { name: "Outstanding loan repayment balance", checkboxName: "exceptions", value: "outstandingLoan" },
        // { name: "Employees on unpaid leave, suspension, or disciplinary leave", checkboxName: "exceptions", value: "unpaidLeave" },
        // { name: "Employees under exit or termination review", checkboxName: "exceptions", value: "exitTermination" },
        // { name: "Outstanding cash advance retirement", checkboxName: "exceptions", value: "outstandingCashAdvance", status:'disabled' },
      ],
      levels: [],
      hasLevels: false,
      approvalArray: [
        { name: "Yes", radioName: "approval", value: true },
        { name: "No", radioName: "approval", value: false },
      ],
      activeArray: [
        { name: "Yes", radioName: "active", value: true },
        { name: "No", radioName: "active", value: false },
      ],
      costArray: [
        { name: "Yes", radioName: "cost", value: true },
        { name: "No", radioName: "cost", value: false },
      ],
      earningArray: [
        { name: "Yes", radioName: "earning", value: true },
        { name: "No", radioName: "earning", value: false },
      ],
      basisArray: [
        { name: "Yes", radioName: "basis", value: true },
        { name: "No", radioName: "basis", value: false },
      ],
      paySlipArray: [
        { name: "Yes", radioName: "paySlip", value: true },
        { name: "No", radioName: "paySlip", value: false },
      ],
      contributionArray: [
        { name: "Yes", radioName: "contribution", value: true },
        { name: "No", radioName: "contribution", value: false },
      ],
      allowValueOverrideArray: [
        { name: "Yes", radioName: "allowValueFormulaOverride", value: true },
        { name: "No", radioName: "allowValueFormulaOverride", value: false },
      ],
      disabledRepaymentDates: {
        to: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      },
      daysArray: [],
      monthsArray: [
        { name: "January", id: "1" },
        { name: " February", id: "2" },
        { name: " March", id: "3" },
        { name: " April", id: "4" },
        { name: " May", id: "5" },
        { name: " June", id: "6" },
        { name: " July", id: "7" },
        { name: " August", id: "8" },
        { name: " September", id: "9" },
        { name: " October", id: "10" },
        { name: " November", id: "11" },
        { name: "   December", id: "12" },
      ],
      requestArray: [
        { name: "On Employee Request", radioName: "request", value: "true" },
        { name: "Company Set Date", radioName: "request", value: "false" },
      ],
      rateTypes: [],
      payItemType: [
        { name: "Regular", id: "regular" },
        { name: "Variable", id: "variable" },
      ],
      error: [],
      rateValue: null,
      loading: true,
      initialPayslipName: "",
      payslipRule: [
        "required",
        {
          name: "payslip",
          rule: (v) => this.validatePayslipName(v),
        },
      ],
    };
  },
  methods: {
    handleOffCycle(value) {
      this.earningCredential.payOffCycle = value;
    },

    handlePayDate(value) {
      const now = value;
      const month = now.getMonth() + 1; // Months are zero-indexed, so add 1
      const date = now.getDate();

      this.earningCredential.payMonth = month;
      this.earningCredential.payStartDay = date;
    },
    async validatePayslipName(value) {
      if (this.initialPayslipName === value) {
        return true;
      }
      const result = await this.$_validateNameInPayslip({
        nameOnPayslip: value,
        orgId: this.$orgId,
        orgPaySettingId: this.$store.state.paySettingsActiveIds.ACTIVE,
      });
      if (!result.data.payItemExist) {
        return true;
      }
      return "This name in Payslip has already been used";
    },
    handlePayableRequestChange(value) {
      if (value === "false") {
        this.earningCredential.payrollCutoffDay = null;
      } else {
        this.earningCredential.payMonth = null;
      }
    },
    convertValue(value) {
      if (value === "true" || value === true) {
        return true;
      }
      return false;
    },
    blockNegativeNumberInput(event) {
      if (["-", "+", "e", "E"].includes(event.key)) {
        event.preventDefault();
      }
    },
    sanitizeNonNegativeNumber(value) {
      if (value === "" || value === null || value === undefined) {
        return null;
      }
      const withoutMinus = String(value).replace(/-/g, "");
      if (withoutMinus === "") {
        return null;
      }
      const num = parseFloat(withoutMinus);
      if (Number.isNaN(num)) {
        return null;
      }
      return num < 0 ? 0 : num;
    },
    onCredentialNumberInput(field, value) {
      this.earningCredential[field] = this.sanitizeNonNegativeNumber(value);
    },
    getPayItems() {
      this.$_getEarnings().then((result) => {
        this.payItemList = result.data.payItems;
        this.ratingType = result.data.rates;
      });
    },
    booleanGross() {
      this.earningCredential.includedInGrossPay =
        this.earningCredential.includedInGrossPay === "true";
    },
    async getLevels() {
      try {
        const response = await this.$_getLevels();
        const { levels } = response.data;

        // Hide levels card if there are no levels
        if (levels.length === 0) {
          this.hasLevels = false;
          return;
        }

        this.levels = levels.map((item) => ({
          levelId: item.id,
          rateValue: null,
          rateType: null,
          orgId: this.$AuthUser.orgId,
          name: item.name,
          id: item.id,
          isAll: false,
        }));

        const allLevels = {
          name: "All Levels",
          id: "0",
          isAll: true,
          rateValue: null,
          rateType: null,
        };
        this.levels.unshift(allLevels);
        this.activeTab = allLevels;

        this.hasLevels = true;
        // eslint-disable-next-line no-empty
      } catch (error) {}
    },
    async handleLevel(tab) {
      try {
        this.activeTab = tab;

        // eslint-disable-next-line no-empty
      } catch (error) {}
    },
    updateLevelsType(value) {
      this.levels = this.levels.map((item) => ({
        ...item,
        rateType: value,
      }));
      this.activeTab.rateType = value;
    },
    async updateLevelsValue(value) {
      try {
        const sanitized = this.sanitizeNonNegativeNumber(value);
        if (sanitized !== value) {
          this.rateValue = sanitized;
          if (this.activeTab) {
            this.activeTab.rateValue = sanitized;
          }
        }

        this.levels = this.levels.map((item) => ({
          ...item,
          rateValue: sanitized,
        }));

        this.activeTab.rateValue = sanitized;

        // eslint-disable-next-line no-empty
      } catch (error) {}
    },
    // eslint-disable-next-line consistent-return
    handlePayItem(value) {
      // if (!this.$route.params.id) {
      const change = this.payItemList.find((item) => item.id === value);
      if (!this.$route.params.id) {
        this.earningCredential.nameOnPayslip = change.name;
      }
      this.earningCredential.payItemSlug = change.slug;

      // Assign Rate types value to the selected item Rate types
      this.rateTypes = change.rateTypes.map((item) => ({
        name: item.label,
        id: item.slug,
      }));

      // Enable request
      this.isDisabledRequest = false;
      // Handle case where Advance is selected
      if (change.slug === "advance" || change.slug === "loan") {
        this.activeTab.rateValue = this.advanceAndLoanLimit;
        this.rateValue = this.advanceAndLoanLimit;
        return this.handleAdvanceAndLoan();
      }
      if (change.slug === "basic") {
        return this.handleBasicSalary();
      }
      if (change.slug === "overtimeAllowance") {
        return this.handleovertimeAllowance();
      }
      this.payItemType = [
        { name: "Regular", id: "regular" },
        { name: "Variable", id: "variable" },
      ];
      if (!this.$route.params.id) {
        this.levels = this.levels.map((item) => ({
          ...item,
          rateValue: this.advanceAndLoanLimit,
        }));
        this.earningCredential.includedInGrossPay = false;
      }
      this.isPayRequest = "false";
      this.isDisabled = false;
      this.isVisible = false;
      this.dateVisible = "true";
      this.isDisabledRequest = true;
      // }
    },

    handleRateType(value) {
      const rateType = this.rateTypes.find((element) => value === element.id);
      if (rateType) {
        this.updateLevelsType(rateType.name);
      }
    },
    // Set variable when Advance OR Loan is selected
    handleAdvanceAndLoan() {
      this.payItemType = [{ name: "Variable", id: "variable" }];
      this.earningCredential.payType = "variable";
      this.earningCredential.rateTypeSlug = "percentGrossEarn";
      this.handleRateType(this.earningCredential.rateTypeSlug);
      this.earningCredential.includedInGrossPay = false;
      this.isDisabled = true;
      this.isPayRequest = "true";
      this.isDisabledRequest = true;
      this.isVisible = true;
    },
    setAdvanceAndLoanLimit(value) {
      this.advanceAndLoanLimit = value;
      this.openAdvanceAndLoansSidebar = false;
    },
    async getAdvanceAndLoanLimit() {
      const response = await this.$_getGeneralAdvanceSettings();
      this.advanceAndLoanLimit = response.data.setting.maxLoanAndAdvanceRequest;
    },
    // Set Regular and Gross pay yes when Basic Salaryis selected
    handle13thMonth() {
      this.payItemType = [{ name: "Variable", id: "variable" }];
      this.earningCredential.includedInGrossPay = true;
      this.earningCredential.payType = "variable";
      this.isPayRequest = "false";
      this.isDisabled = false;
      this.isDisabledRequest = true;
      this.isVisible = false;
    },
    // Set Regular and Gross pay yes when Basic Salaryis selected
    handleBasicSalary() {
      this.payItemType = [{ name: "Regular", id: "regular" }];
      this.earningCredential.includedInGrossPay = true;
      this.earningCredential.payType = "regular";
      this.isPayRequest = false;
      this.isDisabled = true;
      this.isVisible = false;
    },

    handleovertimeAllowance() {
      this.payItemType = [{ name: "Variable", id: "variable" }];
      this.earningCredential.includedInGrossPay = false;
      this.earningCredential.payType = "variable";
      this.isPayRequest = "true";
      this.isDisabled = true;
      this.isDisabledRequest = "true";
      this.isVisible = false;
    },

    handleleaveAllowance() {
      this.isPayRequest = "true";
      this.isDisabled = "true";
      this.isDisabledRequest = "true";
      this.isVisible = false;
    },
    formatDate(date) {
      const d = new Date(date);
      let month = `${d.getMonth() + 1}`;
      let day = `${d.getDate()}`;
      const year = d.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    async saveEarnings() {
      if (!this.creatingEarnings) {
        this.creatingEarnings = true;
        try {
          this.earningCredential.orgId = this.$AuthUser.orgId;
          this.earningCredential.payMonth = this.earningCredential.payMonth ?
           this.earningCredential.payMonth : this.earningCredential.payrollCutoffDay;
          this.earningCredential.interest = this.earningCredential.advanceIsInterestBased === false ||
            this.earningCredential.advanceIsInterestBased === "false" ? 0 : this.earningCredential.interest;
          const orgPaySettingId = this.$store.state.paySettingsActiveIds.ACTIVE || this.$route.query.orgPaySettingId;
          const eligibility = this.eligibilityCheckboxArray.flatMap(el => el.option);
          this.earningCredential.eligibilityGroups = eligibility;
          if (orgPaySettingId) {
            this.earningCredential.orgPaySettingId = orgPaySettingId;
          }
          this.earningCredential.rateValue = this.rateValue;
          this.earningCredential.payOnRequest = this.convertValue(
            this.isPayRequest
          );
          this.levels.shift();
          this.earningCredential.levelsSettings = this.levels.map((level) => {
            let levels = {};

            levels = {
              orgId: level.orgId,
              levelId: level.levelId,
              rateValue: level.rateValue,
              requireApproval: false,
              parentCanOverride: true,
            };
            return levels;
          });
          this.earningCredential.settingType = "earnings";
          if (this.earningCredential.advanceCutoffDate) {
            this.earningCredential.advanceCutoffDate = new Date(
              this.earningCredential.advanceCutoffDate
            ).getDate();
          }

          if (this.isEditState === true) {
            await this.$_updatePayItemSettings(this.earningCredential).then(
              (result) => {
                this.$toasted.success(result.data.message, { duration: 5000 });
              }
            );
          } else {
            await this.$_payItemSetting(this.earningCredential).then(
              (result) => {
                this.$toasted.success(result.data.message, { duration: 5000 });
              }
            );
          }

          this.$router.push({ name: 'PayrollSettings', query: { payType: 'Earnings', orgPaySettingId: this.orgPaySettingId } });

          this.rateValueWasChanged = false;
          this.creatingEarnings = false;
        } catch (error) {
          this.rateValueWasChanged = false;
          this.creatingEarnings = false;
          const errorMessage = error.response?.data?.message || error.message || "An error occurred while saving earnings";
          this.$toasted.error(errorMessage, { duration: 5000 });
          throw new Error(error);
        }
      }
    },
    changePayItem(value) {
      this.categories.map((element) => {
        if (element.id === value) {
          this.payItemList = element.payItems;
        }
        return value;
      });
    },
    handlePayItemList(event) {
      this.earningCredential.advanceEligibilityDays = event.target.value;
    },
    setRateType(rateType) {
      this.earningCredential.rateTypeSlug = rateType;
      this.handleRateType(this.earningCredential.rateTypeSlug);
    },
    addAllLevelsTab() {
      const allLevels = {
        name: "All Levels",
        id: "0",
        isAll: true,
        rateValue: this.earningCredential.rateValue,
      };
      this.levels.unshift(allLevels);
      this.activeTab = allLevels;
    },
    handleIsActive() {
      this.earningCredential.isActive = true;
    },
  },
  computed: {
    disabledRateType() {
      if (this.earningCredential.includedInGrossPay.toString() === "true") {
        this.setRateType("percentGrossEarn");
        return true;
      }
      return false;
    },
    disableIsActive() {
      if (this.earningCredential.includedInGrossPay.toString() === "true") {
        this.handleIsActive();
        return true;
      }
      return false;
    },
    disabledLevelRateValue() {
      return !!(
        this.activeTab.isAll ||
        this.earningCredential.payType === "regular" ||
        (this.earningCredential.payType === "variable" &&
          this.earningCredential.includedInGrossPay.toString() === "true")
      );
    },
  },
  watch: {
    rateValue(value) {
      if (this.earningCredential.includedInGrossPay.toString() === "true") {
        const gross = this.currentGrossPercentage;
        const totalGross = this.previousInGrossPay
          ? gross + (Number(value) - this.previousRateValue)
          : gross + Number(value);
        this.creatingEarnings = false;
        if (totalGross > 100) {
          this.creatingEarnings = true;
          this.error.push(
            `You can not exceed 100% gross earnings distributed across already added pay items. current % is ${totalGross}`
          );
        } else {
          this.error = [];
        }
      }
    },
    isAppointment(value) {
      if (value) {
        this.earningCredential.advanceEligibility = "appointment";
      } else {
        this.earningCredential.advanceEligibility = "confirmation";
      }
    },
  },
  created() {
    if (this.$route.params.id) {
      this.isEditState = true;
    }
  },
  async mounted() {
    for (let i = 1; i < 29; i++) {
      this.daysArray.push({
        name: this.$getOrdinal(i),
        id: i,
      });
    }
    await this.getPayItems();
    await this.getLevels();
    await this.getAdvanceAndLoanLimit();
    await this.$_getOrgGrossTotal(`orgPaySettingId=${this.$store.state.paySettingsActiveIds.ACTIVE ||''}`).then((result) => {
      this.currentGrossPercentage = Number(result.data.currentGross);
      this.loading = false;
    });
    if (this.$route.params.id) {
      this.loading = true;
      this.$_getOnePayItemSettings(this.$route.params.id).then(
        async (result) => {
          this.earningCredential = result.data.paySetting;
          const isoDateTimeString = `${result.data.paySetting.payYear}-${String(
            result.data.paySetting.payMonth
          ).padStart(2, "0")}-${String(
            result.data.paySetting.payStartDay
          ).padStart(2, "0")}T00:00:00.000Z`;
          this.payDate = isoDateTimeString;
          this.initialPayslipName = this.earningCredential.nameOnPayslip;

          if (this.earningCredential.eligibilityGroups && this.earningCredential.eligibilityGroups.length > 0) {
            const selectedEligibilityGroups = new Set(this.earningCredential.eligibilityGroups);

            this.eligibilityCheckboxArray.forEach(item => {
              if (selectedEligibilityGroups.has(item.value)) {
                item.option.push(item.value);
              }
            });
          }

          this.rateValue = this.earningCredential.rateValue;
          this.previousRateValue = this.rateValue;
          this.previousInGrossPay = this.earningCredential.includedInGrossPay;
          // Convert payOffCycle to boolean if it's a string
          if (typeof this.earningCredential.payOffCycle === 'string') {
            this.earningCredential.payOffCycle = this.earningCredential.payOffCycle === 'true';
          } else {
            this.earningCredential.payOffCycle = !!this.earningCredential.payOffCycle;
          }
          this.rateTypes = [
            {
              name: this.earningCredential.rateType.label,
              id: this.earningCredential.rateType.slug,
            },
          ];
          this.earningCredential.payItem.rateTypes = [
            this.earningCredential.rateType,
          ];
          this.payItemList.push(this.earningCredential.payItem);
          this.handleRateType(this.earningCredential.rateTypeSlug);

          this.isPayRequest = this.earningCredential.payOnRequest.toString();

          // populate levels
          this.levelSettings = result.data.levels;
          this.levels = this.levelSettings;
          this.addAllLevelsTab();
          this.handlePayItem(this.earningCredential.payItemId);

          this.loading = false;
        }
      );
    }
  },
};
</script>

<style scoped>
  .warning {
    display: flex;
    align-items: center;
    letter-spacing: 0.5px;
    background-color: #E9932314;
    padding: 10px;
    border-radius: 8px;
    font-size: 12px;
    color: #333333;
    border: 1px solid #E993235C;
  }

  /* Toggle switch */
  .switch {
    position: relative;
    display: inline-block;
    width: 24px;
    height: 12px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #EEEEEE;
    transition: 0.4s;
    border-radius: 20px;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 9.6px;
    width: 9.6px;
    border-radius: 50%;
    left: 2px;
    bottom: 1.5px;
    background-color: #878E99;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: #13B56A;
  }

  input:checked + .slider:before {
    transform: translateX(10px);
    background-color: #ffffff;
  }

  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
</style>
